import { render } from "./analysis_chromatin_interaction.vue?vue&type=template&id=43587f0b&scoped=true"
import script from "./analysis_chromatin_interaction.vue?vue&type=script&lang=js"
export * from "./analysis_chromatin_interaction.vue?vue&type=script&lang=js"

import "./analysis_chromatin_interaction.vue?vue&type=style&index=0&id=43587f0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43587f0b"]])

export default __exports__